import React, { useMemo, useState } from 'react'

import { Icon, Typography } from 'antd'

import CustomInput from '../../../../../../components/CustomInput/customInput'
import CustomSelect from '../../../../../../components/CustomSelect/customSelect'
import { getMessage } from '../../../../../../util/IntlMessages'

import './styles.less'

export const ViewParams = ({ allCustomFields = [], customField, setField, selectedFieldId, errors = {} }) => {
  const [showParams, setShowParams] = useState(false)

  const referenceFields = useMemo(() => {
    let fields = []
    allCustomFields.forEach((field) => {
      if (field.children) {
        field.children.map((child) => fields.push({ value: child.id, description: child.fieldName }))
      }

      if (field.fieldType === 'group') return
      return fields.push({ value: field.id, description: field.fieldName })
    })

    fields = fields.filter(({ value }) => !isNaN(value) && customField.id !== value)

    return fields
  }, [allCustomFields, customField])

  return (
    <div>
      {customField.fieldType !== 'group' && (
        <div className="viewParams">
          <div className="horizontal-line viewParams__divider" />

          <div className="viewParams__titleWrapper">
            <Typography className="viewParams__title">{getMessage('viewParams')}</Typography>
            {showParams ? (
              <Icon type="minus-square" onClick={() => setShowParams(false)} className="viewParams__plusIcon" />
            ) : (
              <Icon type="plus-square" onClick={() => setShowParams(true)} className="viewParams__plusIcon" />
            )}
          </div>

          {showParams && (
            <div className="viewParams__content">
              <CustomSelect
                field="parentFieldId"
                errors={errors}
                setFieldValue={(property, value) => setField({ property, value, fieldId: selectedFieldId })}
                rowSpan={25}
                value={customField}
                values={referenceFields}
              />
              {/* <CustomSelect */}
              {/*  field="parentFieldOperator" */}
              {/*  errors={errors} */}
              {/*  setFieldValue={setField} */}
              {/*  rowSpan={25} */}
              {/*  value={customField} */}
              {/*  values={LOGICAL_OPERATORS} */}
              {/* /> */}
              <CustomInput
                field="parentFieldAnswer"
                type="text"
                errors={errors}
                setFieldValue={(property, value) => setField({ property, value, fieldId: selectedFieldId })}
                rowSpan={25}
                value={customField}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
